import { User } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgUser = mkIcon(User);
